module.exports = __webpack_public_path__ + "img/foto3.a12ad928.webp";